export default __webpack_public_path__ + "static/media/LinkedId.1dd83e69.svg";